import { Button, Grid } from '@mui/material';
import React, { useState } from 'react';

import Modal from '../../../../Modal/Modal';

export type ShippingExplanationModalProps = {
  content: ShippingExplanationModalContent;
  onOpen?: () => unknown;
  onClose?: () => unknown;
};

export type ShippingExplanationModalBullet = {
  icon: React.JSX.Element;
  title: string;
  text: string;
};

export type ShippingExplanationModalContent = {
  title: string;
  cta: string;
  bullets: ShippingExplanationModalBullet[];
};

export const ShippingExplanationModal = (props: ShippingExplanationModalProps) => {
  const { onClose, onOpen, content } = props;

  const [isModalOpen, setModalOpen] = useState(false);

  const onModalOpen = () => {
    setModalOpen(true);
    onOpen?.();
  };
  const onCloseModal = () => {
    setModalOpen(false);
    onClose?.();
  };

  return (
    <>
      <Button variant="contained" size="large" color="primary" onClick={onModalOpen} disableElevation fullWidth>
        {content.title}
      </Button>

      <Modal
        open={isModalOpen}
        title={content.title}
        onClose={onCloseModal}
        closeIconVisible
        maxWidth="xs"
        className="shipping-explanation-modal"
        actions={[
          <Button
            variant="contained"
            key="shipping-explanation-modal-action"
            color="primary"
            size="large"
            className="locker-modal-cta"
            onClick={onCloseModal}
            fullWidth={true}
          >
            {content.cta}
          </Button>,
        ]}
      >
        <Grid container>
          <div className="shipping-explanation-modal-content">
            <div className="shipping-explanation-modal-content-bullets">
              {content.bullets.map((bullet) => (
                <div className="bullet" key={bullet.title}>
                  <div className="bullet-icon">{bullet.icon}</div>
                  <div className="bullet-content">
                    <div className="bullet-title">{bullet.title}</div>
                    <div className="bullet-text" dangerouslySetInnerHTML={{ __html: bullet.text }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Grid>
      </Modal>
    </>
  );
};
